import { combineReducers } from 'redux';

import {
  SET_SIGNATURES_NUMBER,
  SET_IS_MATCH,
  SET_PHOTO,
  SET_ERROR,
  UPDATE_PETITION_FORM,
  GET_FIELD_REPORT_REQUEST,
  GET_FIELD_REPORT_SUCCESS,
  GET_FIELD_REPORT_FAILURE,
  POST_FIELD_REPORT_REQUEST,
  POST_FIELD_REPORT_SUCCESS,
  POST_FIELD_REPORT_FAILURE,
  SET_LOADING_STATUS_CHECK_IN,
  MARK_AS_PHYSICALLY_CHECKED_IN_REQUEST,
  MARK_AS_PHYSICALLY_CHECKED_IN_SUCCESS,
  MARK_AS_PHYSICALLY_CHECKED_IN_FAILURE,
  INVALIDATE_PETITION_SUCCESS,
  INVALIDATE_PETITION_REQUEST,
  INVALIDATE_PETITION_FAILED,
  SET_SIGN_ON_LINE_NUMBER,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
  petition: null,
  petitionFormData: null,
  match: 1,
  photos: null,
  signatures: 1,
  signOnSignatureLineNumber: 0,
  signaturesInfo: [],
};

const mainReducer = (state = initialState, {
  type, photos, match, petition,
  signatures, error, petitionFormData,
  signOnSignatureLineNumber, loading,
}) => {
  switch (type) {
    case SET_PHOTO:
      return {
        ...state,
        error: '',
        photos,
      };
    case SET_SIGNATURES_NUMBER:
      return {
        ...state,
        signatures,
      };
    case SET_SIGN_ON_LINE_NUMBER:
      return {
        ...state,
        signOnSignatureLineNumber,
      };
    case SET_IS_MATCH:
      return {
        ...state,
        match,
      };
    case UPDATE_PETITION_FORM:
      return {
        ...state,
        petitionFormData: {
          ...state.petitionFormData,
          ...petitionFormData,
        },
      };
    case GET_FIELD_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        petitionFormData: null,
        photos: null,
        error: null,
      };
    case GET_FIELD_REPORT_SUCCESS:
      return {
        ...state,
        petition: {
          ...petition,
          id: petition.id,
          canvasser: petition.canvasser,
          isBlank: petition.method === 'blank' || petition.method === 'signature_rejected',
          isScanned: petition.scanned_at,
        },
        signer: petition.prospects[0] || null,
        petitionFormData: {
          first_name: petition.signer?.first_name,
          last_name: petition.signer?.last_name,
          address: petition.signer?.address,
          city: petition.signer?.city,
          state: petition.signer?.state,
          zip: petition.signer?.zip,
        },
        loading: false,
      };
    case GET_FIELD_REPORT_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      };
    case POST_FIELD_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case POST_FIELD_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case POST_FIELD_REPORT_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      };
    case MARK_AS_PHYSICALLY_CHECKED_IN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MARK_AS_PHYSICALLY_CHECKED_IN_SUCCESS:
      return {
        ...state,
        loading: false,
        petitionFormData: null,
        photos: null,
      };
    case MARK_AS_PHYSICALLY_CHECKED_IN_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      };
    case SET_ERROR:
      return {
        ...state,
        error,
        loading: false,
      };
    case SET_LOADING_STATUS_CHECK_IN:
      return {
        ...state,
        loading,
      };
    case INVALIDATE_PETITION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case INVALIDATE_PETITION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case INVALIDATE_PETITION_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};

const fieldReportReducer = combineReducers({
  main: mainReducer,
});

export default fieldReportReducer;
